import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

domReady(() => {
  const sliders = document.querySelectorAll('.slider-specialities__swiper');

  if (0 < sliders.length) {
    sliders.forEach((slider) => {
      const section = slider.closest('.slider-specialities');

      new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        centeredSlides: true,
        speed: 700,
        loop: true,
        observer: true,
        observeParents: true,

        breakpoints: {
          600: {
            spaceBetween: 20,
          },
          980: {
            spaceBetween: 24,
            centeredSlides: false,
          },
        },

        navigation: {
          prevEl: [...section.querySelectorAll('.swiper-button-prev')],
          nextEl: [...section.querySelectorAll('.swiper-button-next')],
        },
      });
    });
  }
});
